module.exports = __webpack_public_path__ + "assets/2474e038a3066ffd21e257e0dd9c23a6.png";